import { i18n } from '@lingui/core'

// Import compiled messages (they're in CommonJS format)
const enMessages = require('./locales/en/messages').messages;
const heMessages = require('./locales/he/messages').messages;

i18n.load('en', enMessages);
i18n.load('he', heMessages);
i18n.activate('en');

export { i18n } 
